import React from 'react'
import { BiChevronLeftCircle, BiChevronRightCircle } from 'react-icons/bi'

function Arrows({ prevSlide, nextSlide }) {
  return (
    <div className='arrows'>
      <span className="prev" onClick={prevSlide}>
        <BiChevronLeftCircle className='h-10 w-10 text-light-400 hover:text-mix-400 cursor-pointer'/>
      </span>

      <span className="next" onClick={nextSlide}>
       <BiChevronRightCircle className='h-10 w-10 text-light-400 hover:text-mix-400 cursor-pointer'/>
      </span>
    </div>
  )
}

export default Arrows
